import styles from '../../LotteryGameRoomBodyWinners.module.scss';
import cx from 'classnames';

import { LotteryJackpotHistoryWinnerDto } from '@app/store/api/historyApi';
import { UserDto } from '@app/store/api/restApi';
import { JackpotSlug } from '@entities/jackpot';
import { LotteryFrontJackpot } from '@features/LotteryGame/types';
import { Avatar } from '@shared/Avatar';
import { JackpotIcon } from '@shared/JackpotIcon/JackpotIcon';
import { Typography } from '@shared/Typography';
import { getDrawAmount } from './lib';

export const WinNumber = ({ place, winNumber }: { place: number; winNumber: number }) => {
  return (
    <div
      className={cx(
        styles.lgrbwListItemPlace,
        { [styles.lgrbwListItemPlaceFirst]: place === 1 },
        { [styles.lgrbwListItemPlaceSecond]: place === 2 },
        { [styles.lgrbwListItemPlaceThird]: place === 3 },
      )}
    >
      <Typography
        component="h3"
        variant={'primary'}
        className={cx(
          { [styles.lgrbwListItemNumFirst]: place === 1 },
          { [styles.lgrbwListItemNumSecond]: place === 2 },
          { [styles.lgrbwListItemNumThird]: place === 3 },
        )}
      >
        {winNumber}
      </Typography>
    </div>
  );
};

export const Jackpots = ({
  jackpots,
}: {
  jackpots?: LotteryFrontJackpot[] | LotteryJackpotHistoryWinnerDto[];
}) => {
  const jacpotsCount = !jackpots
    ? 0
    : 'count' in jackpots[0]
    ? jackpots[0].count
    : jackpots[0].numJackpotTickets;

  return (
    <>
      {jackpots && jackpots.length > 0 && (
        <div className={styles.lgrbwTickets}>
          <Typography component="description2">x{jacpotsCount}</Typography>
          <div className={styles.resultTicketsList}>
            {jackpots.map((winTicket, index) => (
              <JackpotIcon
                size={15}
                key={index}
                leftDirection
                drawAmount={getDrawAmount(winTicket)}
                jackpotSlug={winTicket.jackpotSlug as JackpotSlug}
                className={index > 0 ? styles.ptWinBetTicketLeft : undefined}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export const UserInfo = ({
  user,
  avatar,
  userDisplayNumber,
  winnerPlayer,
  hasMultiplier,
}: {
  user?: UserDto;
  avatar?: string;
  userDisplayNumber?: number;
  winnerPlayer: number;
  hasMultiplier?: boolean;
}) => {
  const iAmPlayer =
    userDisplayNumber && String(userDisplayNumber) === String(winnerPlayer);

  return (
    <div className={styles.userInfo}>
      <Avatar
        small
        className={styles.lgrbwAvatar}
        src={iAmPlayer && avatar ? avatar : ''}
      />

      <Typography
        component="h3"
        className={cx(styles.lgrbwListItemName, iAmPlayer && styles.lgrbwMyName, {
          [styles.lgrbwMyNameShort]: hasMultiplier,
        })}
      >
        {iAmPlayer && user?.username ? user.username : `#${winnerPlayer}`}
      </Typography>
    </div>
  );
};
